import { useCurrentUserContext } from 'contexts/currentUser';
import { LIFECYCLE, Lifecycle } from 'hooks/useLifecycle';

export const useRivalsSawWelcomeToTheArena = () => {
  const { currentUser } = useCurrentUserContext();

  const lifecycle = currentUser?.userSettings.lifecycle as Lifecycle;

  return lifecycle?.[LIFECYCLE.sawWelcomeToSeasonsArena];
};
